import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=6ac0abb4&scoped=true&"
import script from "./SchoolList.vue?vue&type=script&lang=js&"
export * from "./SchoolList.vue?vue&type=script&lang=js&"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=6ac0abb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac0abb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
